import script from "./QrReaderPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./QrReaderPage.vue?vue&type=script&setup=true&lang=ts"

import "./QrReaderPage.vue?vue&type=style&index=0&id=61b606c6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61b606c6"]])

export default __exports__